import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientAccess } from '@core-interactions/models/client-access';
import { Module } from '@core-interactions/models/module';
import { ENVIRONMENT } from '@env/environment';
import { ClientPowerBIReport } from '@power-bi/models/client-power-bi-report';
import { AccountType } from '@stores/models/app/account-type';

@Injectable()
export class AccessService {
  readonly #httpClient = inject(HttpClient);

  readonly #coreApiUrl = ENVIRONMENT.coreApi.endpoint;

  loadModules(): Observable<Module[]> {
    return this.#httpClient.get<Module[]>(`${this.#coreApiUrl}/module/list`);
  }

  loadClients(): Observable<ClientAccess[]> {
    return this.#httpClient.get<ClientAccess[]>(
      `${this.#coreApiUrl}/access/clients/${ENVIRONMENT.moduleId}`
    );
  }

  loadReports(accountType: AccountType): Observable<ClientPowerBIReport[]> {
    const activeOnlyQuery =
      accountType === AccountType.SystemAdmin ? '?activeOnly=true' : '';

    return this.#httpClient.get<ClientPowerBIReport[]>(
      `${this.#coreApiUrl}/powerbi/reports/list${activeOnlyQuery}`
    );
  }
}
